/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryOptions } from 'src/store/fetch-services';
import { FlightFollowingReportEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  FlightFollowingReportProps,
  FlightFollowingReportViewModelBase,
} from 'src/store/generated/flight-following-report-record.generated';

export class FlightFollowingReportViewModel extends FlightFollowingReportViewModelBase {
  constructor(props: FlightFollowingReportProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class FlightFollowingReportViewModelService {
  constructor(
    private readonly _flightFollowingReportEntityFetchService: FlightFollowingReportEntityFetchService,
  ) {}

  public getById(
    id: string,
    options?: QueryOptions,
  ): Observable<FlightFollowingReportViewModel | undefined> {
    return this._flightFollowingReportEntityFetchService.getById(id, options).pipe(
      map((flightFollowingReport) => {
        if (flightFollowingReport == null) {
          return undefined;
        }
        return new FlightFollowingReportViewModel(flightFollowingReport);
      }),
    );
  }
}
